<template>
  <div class="HeaderSelect">
    <!-- <span>{{languageMap['欢迎']}} {{ userName }}</span>&nbsp;&nbsp;
    <el-dropdown>
      <i class="el-icon-setting" style="margin-right: 15px; cursor: pointer;"><span> {{languageMap['设置']}}</span></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-if="referrer" @click.native="goJiKong">{{languageMap['返回集控']}}</el-dropdown-item>
        <el-dropdown-item v-else @click.native="outLogin">{{languageMap['退出登陆']}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    <span style="margin-right: 20px;">网站浏览次数：{{websiteBrowseCount}}</span>


    <span style="margin-right: 180px;">欢迎您，{{ userName }}</span>&nbsp;&nbsp;
    <div style="right: 0px;top: 34px;position: fixed;cursor: pointer">
      <img src="../assets/images/replaceImg/off.png" v-if="referrer" @click="goJiKong" style="position: absolute;right: 14px;top: -18px;"/>
       <img src="../assets/images/replaceImg/off.png" v-else @click="outLogin" style="position: absolute;right: 14px;top: -18px;"/>
   <!--  <span style="margin-right: 90px;">欢迎您，{{ userName }}</span>&nbsp;&nbsp;
    <el-dropdown>
      <img src="../assets/images/replaceImg/off.png" style="position: absolute;right: 14px;top: -18px;"/>
      <i class="el-icon-setting" style="margin-right: 21px; cursor: pointer;"><span> 设置</span></i>
      <el-dropdown-menu slot="dropdown"> -->
        <!-- <el-dropdown-item>修改密码</el-dropdown-item> -->
        <!-- <el-dropdown-item v-if="referrer" @click.native="goJiKong">返回集控</el-dropdown-item>
        <el-dropdown-item v-else @click.native="outLogin">退出登陆</el-dropdown-item>
      </el-dropdown-menu>-->
    </div> 
  </div>
</template>

<script>
import store from "@/store";
import config from "@/config";

export default {
  name: "HeaderSelect",
  props: {},
  data() {
    return {
      timer: null,
      userName: null,
      referrer: sessionStorage.getItem("referrer") || null,
      websiteBrowseCount: null
    };
  },
  mounted() {
    this.userName = sessionStorage.getItem("userName") || null;

    if(!sessionStorage.getItem("userName")){
      this.getCurrentLoginUser();
    }
    this.init();
    this.queryWebsiteBrowseCount();
  },
  beforeDestroy() {
  },
  methods: {
    init(){  //this.languageMap['初始化']
       
    },
 getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    getCurrentLoginUser() {
      let url = config.url + "SysUserController/getCurrentLoginUser.action";
      let param = {}
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
          sessionStorage.setItem("userName", data.data.userName);
          sessionStorage.setItem("sysRole", data.data.sysRole);
          this.userName = data.data.userName;
          this.sysRole = data.data.sysRole;
        }
      })
    },
    outLogin() {
      let url = config.url + "SysUserController/outLogin.action";
      let param = {}
      this.$http.post(url, param).then(res => {
      })

      store.state.token = "";
      store.state.optionsProject = [];
      store.state.optionsGroup = [];
      store.state.valueProject = "";
      store.state.valueGroup = "";
      store.state.nodeInfoOnlineNum = {};
      sessionStorage.removeItem("userName");
      sessionStorage.removeItem("token");
      this.$router.push({ path: "/backLogin" });
    },
    goJiKong() {
      sessionStorage.removeItem("fromSys");
      sessionStorage.removeItem("referrer");
      window.location.href = this.referrer + "#/back/home";
    },
    queryWebsiteBrowseCount() {
      let url = config.url + "BackController/queryWebsiteBrowseCount.action";
      let param = {}
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
          if(data.data){
            this.websiteBrowseCount = data.data.count;
          }
        }
      })
    }
  }
};
</script>

<style lang="sass" scoped>
.HeaderSelect
  color: #ffffff
  position: fixed
  z-index: 103
  top: 10px
  right: 0px
  line-height: 60px
  .el-select
    width: 140px
.el-dropdown
  display: inline
  z-index: 104
  color: #ffffff !important
  i
    color: #409eff
    span
      color: #ffffff
</style>
